import i18n from '@/i18n';
import {WorkTimeEntryStatus} from '@/services/graphqlHooks';

const workTimeEntryStatuses: Record<WorkTimeEntryStatus, string> = {
  [WorkTimeEntryStatus.Approved]: i18n.t('Approved'),
  [WorkTimeEntryStatus.Pending]: i18n.t('Pending'),
  [WorkTimeEntryStatus.Rejected]: i18n.t('Rejected'),
};

export default workTimeEntryStatuses;
